import { Eula, RawEula } from 'records/Eula';
import GQLRequest from 'utils/GQLRequest';

export const getEula = async (): Promise<Eula> => {
  const { isEulaAccepted } = await new GQLRequest()
    .query(
      `
      query IsEulaAccepted {
        isEulaAccepted {
          accepted
          url
          firstname
          lastname
          discipline
          company
          role
        }
      }
      `
    )
    .json<{ isEulaAccepted: RawEula }>();

  return Eula.deserialize(isEulaAccepted);
};

export const acceptEula = async (): Promise<boolean> => {
  const resp = await new GQLRequest()
    .query(
      `
      mutation AcceptEula {
        acceptEula 
      }
      `
    )
    .json<{ acceptEula: boolean }>();

  return resp.acceptEula;
};

export const getTosLink = async (projecttype: string): Promise<string> => {
  const resp = await new GQLRequest()
    .query(
      `
      query Toslink($projecttype: String!){
        toslink(projecttype: $projecttype)
        }
      `
    )
    .variables({ projecttype })
    .json<{ toslink: string }>();

  return resp.toslink;
};
